module.exports = __webpack_public_path__ + "img/CONNECTED.e871bb0d.svg";